import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './stockUpload.module.css';

// ÐÐ°ÑÐ¸Ð½Ñ, Ðº ÐºÐ¾ÑÐ¾ÑÑÐ¼ ÐµÑÑÑ Ð·Ð°Ð¼ÐµÑÐ°Ð½Ð¸Ðµ, ÑÐ¿Ð¸ÑÐºÐ¾Ð¼: ÑÐ°Ð½ÑÑÐµ Ð¿Ð»Ð°ÑÐºÐ° Ð½Ð°Ð·ÑÐ²Ð°Ð»Ð° ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ¸ÑÐ»Ð¾,
// Ð¸ Ð¸ÑÐºÐ°ÑÑ ÑÑÐ¸ Ð¼Ð°ÑÐ¸Ð½Ñ Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ð»Ð¾ÑÑ Ð² Ð±Ð°Ð·Ðµ Ð¿Ð¾ VIN Ð¸Ð· Ð²ÑÐ³ÑÑÐ·ÐºÐ¸. VIN Ð²ÐµÐ´ÑÑ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÑ
// Ð¼Ð°ÑÐ¸Ð½Ñ â ÑÑÐ´Ð°, Ð³Ð´Ðµ Ð·Ð°Ð¿Ð¾Ð»Ð½ÑÐµÑÑÑ Ð¾Ð±ÑÑÐ¼
const CarList = ({ cars }) => {
  if (!cars.length) return null;
  return (
    <details className={styles.noticeCars}>
      <summary>ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ Ð¼Ð°ÑÐ¸Ð½Ñ ({cars.length})</summary>
      <ul>
        {cars.map((c, i) => (
          <li key={`${c.fileName}-${c.row}-${c.kind}-${i}`}>
            {c.carId ? (
              <Link to={`/cars/car/${c.carId}/main-data`}>{c.vin || `Ð¼Ð°ÑÐ¸Ð½Ð° ${c.carId}`}</Link>
            ) : (
              <b>{c.vin || 'Ð±ÐµÐ· VIN'}</b>
            )}{' '}
            â {[c.markName, c.modelName, c.complectationName].filter(Boolean).join(' ')}
            {c.issueYear ? `, ${c.issueYear}` : ''}
            {c.cityName ? `, ${c.cityName}` : ''}
            {c.row ? ` Â· ÑÑÑÐ¾ÐºÐ° ${c.row}` : ''}
          </li>
        ))}
      </ul>
    </details>
  );
};

// Ð¢ÑÐ¸ Ð¿Ð»Ð°ÑÐºÐ¸ Ð¿Ð¾Ð´ Ð¸ÑÐ¾Ð³Ð°Ð¼Ð¸ Ð¸Ð¼Ð¿Ð¾ÑÑÐ°; Ð¾Ð´Ð½Ð¸ Ð¸ ÑÐµ Ð¶Ðµ Ð´Ð»Ñ ÑÑÐ¿ÐµÑÐ½Ð¾Ð³Ð¾ Ð¸ Ð½ÐµÑÑÐ¿ÐµÑÐ½Ð¾Ð³Ð¾ ÑÐµÐ·ÑÐ»ÑÑÐ°ÑÐ°
const StockImportNotices = ({ result }) => {
  const navigate = useNavigate();
  const of = (kind) => (result.carWarnings || []).filter((w) => w.kind === kind);

  return (
    <>
      {/* ÐÐ°ÑÐ¸Ð½Ñ Ð±ÐµÐ· Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð¿ÑÐ¸ÐµÑÐ°Ð»Ð¸ Ñ ÑÐµÐ½Ð¾Ð¹ Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÐ° Ð¸ ÑÐ¶Ðµ Ð²Ð¸Ð´Ð½Ñ Ð² Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¸ â
          ÑÑÐ¾ ÑÐ¾Ð²Ð½Ð¾ ÑÐ° ÐºÑÐ¸Ð²Ð°Ñ ÑÐµÐ½Ð°, ÑÐ°Ð´Ð¸ ÐºÐ¾ÑÐ¾ÑÐ¾Ð¹ Ð·Ð°Ð²Ð¾Ð´Ð¸Ð»ÑÑ Ð¿ÑÐ°Ð¹Ñ. ÐÐ¾Ð»ÑÐ°ÑÑ Ð¾ Ð½ÐµÐ¹ Ð½ÐµÐ»ÑÐ·Ñ:
          Ð¸Ð½Ð°ÑÐµ Ð¾Ð½Ð° Ð²ÑÐ¿Ð»ÑÐ²ÑÑ, ÑÐ¾Ð»ÑÐºÐ¾ ÐµÑÐ»Ð¸ ÐºÑÐ¾-ÑÐ¾ ÑÐ°Ð¼ Ð·Ð°Ð³Ð»ÑÐ½ÐµÑ Ð² ÑÐºÑÐ°Ð½ Ð¿ÑÐ°Ð¹ÑÐ° */}
      {result.noPriceRule > 0 && (
        <div className={styles.noRuleNotice}>
          {result.noPriceRule} Ð¼Ð°ÑÐ¸Ð½ Ð¿ÑÐ¸ÐµÑÐ°Ð»Ð¸ Ñ ÑÐµÐ½Ð¾Ð¹ Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÐ° â Ð¿Ð¾Ð´ Ð½Ð¸Ñ Ð½ÐµÑ Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð² Ð¿ÑÐ°Ð¹ÑÐµ.{' '}
          <button type="button" onClick={() => navigate('/price-list')}>
            ÐÑÐºÑÑÑÑ Ð¿ÑÐ°Ð¹Ñ Ð¿Ð¾ Ð¿ÑÐ¸ÐºÐ°Ð·Ñ
          </button>
          <CarList cars={of('noPriceRule')} />
        </div>
      )}
      {/* Ð¦ÐµÐ½Ñ Ð½ÐµÑ Ð½Ð¸ Ð² ÑÐ°Ð¹Ð»Ðµ, Ð½Ð¸ Ñ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ°. ÐÐ°ÑÐ¸Ð½Ð° Ð² ÑÑÐ¾ÐºÐµ, Ð½Ð¾ Ñ Ð½ÑÐ»ÑÐ¼ â Ð¸ Ð¾Ð± ÑÑÐ¾Ð¼
          Ð½Ð°Ð´Ð¾ ÑÐºÐ°Ð·Ð°ÑÑ Ð³ÑÐ¾Ð¼ÑÐµ, ÑÐµÐ¼ Ð¿ÑÐ¾ ÑÐµÐ½Ñ Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÐ°: Ð½Ð¾Ð»Ñ Ð²Ð¸Ð´ÐµÐ½ ÐºÐ»Ð¸ÐµÐ½ÑÑ */}
      {result.noPrice > 0 && (
        <div className={styles.noRuleNotice}>
          {result.noPrice} Ð¼Ð°ÑÐ¸Ð½ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ñ Ð±ÐµÐ· ÑÐµÐ½Ñ â ÐµÑ Ð½ÐµÑ Ð½Ð¸ Ð² Ð²ÑÐ³ÑÑÐ·ÐºÐµ, Ð½Ð¸ Ð² Ð¿ÑÐ°Ð¹ÑÐµ Ð¿Ð¾ Ð¿ÑÐ¸ÐºÐ°Ð·Ñ. Ð ÑÑÐ¾ÐºÐµ Ð¾Ð½Ð¸
          ÑÑÐ¾ÑÑ 0 â¸, Ð¿Ð¾ÐºÐ° Ð½Ðµ Ð¿Ð¾ÑÐ²Ð¸ÑÑÑ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾.{' '}
          <button type="button" onClick={() => navigate('/price-list')}>
            ÐÐ°Ð²ÐµÑÑÐ¸ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ Ð² Ð¿ÑÐ°Ð¹ÑÐµ
          </button>
          <CarList cars={of('noPrice')} />
        </div>
      )}
      {/* ÐÐ±ÑÑÐ¼ Ð½Ðµ Ð¿ÑÐ¸ÑÑÐ» Ð½Ð¸ Ð¸Ð· Ð²ÑÐ³ÑÑÐ·ÐºÐ¸, Ð½Ð¸ Ð¸Ð· ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸. ÐÐ°Ð½ÐºÐ¸ Ð¸ÑÑÑ Ð¼Ð¾Ð´ÐµÐ»Ñ Ð¿Ð¾
          Ð¾Ð±ÑÑÐ¼Ñ, Ð¸ Ð·Ð°ÑÐ²ÐºÐ° Ð¿Ð¾ ÑÐ°ÐºÐ¾Ð¹ Ð¼Ð°ÑÐ¸Ð½Ðµ Ð½Ðµ ÑÐ¹Ð´ÑÑ â Ð° Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ ÑÐ·Ð½Ð°Ð» Ð±Ñ Ð¾Ð± ÑÑÐ¾Ð¼ ÑÐ¾Ð»ÑÐºÐ¾
          Ð¸Ð· ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ Ð¼Ð°ÑÐ¸Ð½Ñ, ÑÐ¶Ðµ Ð½Ð° ÑÐ´ÐµÐ»ÐºÐµ */}
      {result.noEngineVolume > 0 && (
        <div className={styles.noRuleNotice}>
          {result.noEngineVolume} Ð¼Ð°ÑÐ¸Ð½ Ð±ÐµÐ· Ð¾Ð±ÑÑÐ¼Ð° Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ â Ð·Ð°ÑÐ²ÐºÐ° Ð¿Ð¾ Ð½Ð¸Ð¼ Ð½Ðµ ÑÐ¹Ð´ÑÑ Ð² Ð±Ð°Ð½ÐºÐ¸. ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ Ð¾Ð±ÑÑÐ¼ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ
          Ð¼Ð°ÑÐ¸Ð½Ñ (Ð² ÑÐ¼Â³, Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ 1499).
          <CarList cars={of('noEngineVolume')} />
        </div>
      )}
    </>
  );
};

export default StockImportNotices;
